export const headerHeight = '250px';
export const padding = '60px';
export const mainHeight = `calc(100vh - ${headerHeight})`;
export const slideHeight = `calc(${mainHeight} - (2 * ${padding}))`;
export const slideWidth = `calc(100vw - (2 * ${padding}))`;
